(function () {
  'use strict';

  var DESKTOP_QUERY = '(hover: hover) and (pointer: fine)';
  var DRAG_THRESHOLD = 6;
  var desktopMQ = window.matchMedia(DESKTOP_QUERY);

  // One shared ResizeObserver for every card.
  var sharedResizeObserver = null;
  if (typeof ResizeObserver !== 'undefined') {
    sharedResizeObserver = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var fn = entries[i].target._cardCarouselMeasure;
        if (fn) fn();
      }
    });
  }

  function hydrateLazyImages(card) {
    var imgs = card.querySelectorAll('img[data-lazy-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var ss = img.getAttribute('data-lazy-srcset');
      var src = img.getAttribute('data-lazy-src');
      if (ss) img.setAttribute('srcset', ss);
      if (src) img.setAttribute('src', src);
      img.removeAttribute('data-lazy-src');
      img.removeAttribute('data-lazy-srcset');
    }
  }

  function init(card) {
    if (!card || card.dataset.carouselReady === '1') return;

    var viewport = card.querySelector('[data-carousel-viewport]');
    var track = card.querySelector('[data-carousel-track]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('.card-product-carousel__slide');
    var count = slides.length;
    if (count <= 1) {
      card.dataset.carouselReady = '1';
      return;
    }

    var dots = card.querySelectorAll('[data-carousel-dot]');
    var current = 0;
    var dragging = false;
    var moved = false;
    var startX = 0;
    var startY = 0;
    var startTranslate = 0;
    var currentTranslate = 0;
    var pointerId = null;
    var cachedRect = null;
    var width = 0;
    var hydrated = false;

    function refreshRect() {
      cachedRect = viewport.getBoundingClientRect();
      width = cachedRect.width || width;
    }

    function ensureHydrated() {
      if (hydrated) return;
      hydrated = true;
      hydrateLazyImages(card);
    }

    function setActive(index) {
      if (index < 0) index = 0;
      if (index > count - 1) index = count - 1;
      current = index;
      currentTranslate = -current * width;
      track.style.transform = 'translate3d(' + currentTranslate + 'px, 0, 0)';
      if (!dots || dots.length === 0) return;
      for (var i = 0; i < dots.length; i++) {
        if (i === current) {
          dots[i].classList.add('is-active');
        } else {
          dots[i].classList.remove('is-active');
        }
      }
    }

    function applyTransition(on) {
      track.style.transition = on ? 'transform 250ms ease-out' : 'none';
    }

    function measure() {
      refreshRect();
      applyTransition(false);
      setActive(current);
    }

    viewport._cardCarouselMeasure = measure;
    if (sharedResizeObserver) {
      sharedResizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', measure);
    }

    // ---- Desktop: hover position → slide ----
    function onMouseEnter() {
      if (!desktopMQ.matches) return;
      refreshRect();
      ensureHydrated();
    }

    function onMouseMoveDesktop(e) {
      if (!desktopMQ.matches || !cachedRect) return;
      var x = e.clientX - cachedRect.left;
      if (x < 0) x = 0;
      if (x > cachedRect.width) x = cachedRect.width;
      var index = Math.floor((x / cachedRect.width) * count);
      if (index >= count) index = count - 1;
      if (index !== current) {
        applyTransition(true);
        setActive(index);
      }
    }

    function onMouseLeaveDesktop() {
      if (!desktopMQ.matches) return;
      applyTransition(true);
      setActive(0);
    }

    viewport.addEventListener('mouseenter', onMouseEnter);
    viewport.addEventListener('mousemove', onMouseMoveDesktop);
    viewport.addEventListener('mouseleave', onMouseLeaveDesktop);

    // ---- Mobile / touch: drag/swipe ----
    function pointerIsTouch(e) {
      return e.pointerType === 'touch' || e.pointerType === 'pen';
    }

    function onPointerDown(e) {
      if (!pointerIsTouch(e)) return;
      ensureHydrated();
      dragging = true;
      moved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      refreshRect();
      startTranslate = -current * width;
      applyTransition(false);
      try {
        viewport.setPointerCapture(e.pointerId);
      } catch (_) {}
    }

    function onPointerMove(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;

      if (!moved) {
        if (Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          moved = true;
        } else if (Math.abs(dy) > DRAG_THRESHOLD) {
          cancel();
          return;
        } else {
          return;
        }
      }

      var translate = startTranslate + dx;
      var minTranslate = -(count - 1) * width;
      if (translate > 0) translate = translate / 3;
      if (translate < minTranslate) translate = minTranslate + (translate - minTranslate) / 3;
      currentTranslate = translate;
      track.style.transform = 'translate3d(' + translate + 'px, 0, 0)';

      e.preventDefault();
    }

    function settle() {
      var dx = currentTranslate - startTranslate;
      var threshold = width * 0.15;
      var next = current;
      if (dx <= -threshold) next = current + 1;
      else if (dx >= threshold) next = current - 1;
      applyTransition(true);
      setActive(next);
    }

    function onPointerUp(e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var didMove = moved;
      dragging = false;
      pointerId = null;
      try {
        viewport.releasePointerCapture(e.pointerId);
      } catch (_) {}

      if (didMove) {
        settle();
      } else {
        applyTransition(true);
        setActive(current);
      }

      if (didMove) {
        var swallow = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          card.removeEventListener('click', swallow, true);
        };
        card.addEventListener('click', swallow, true);
        setTimeout(function () {
          card.removeEventListener('click', swallow, true);
        }, 350);
      }
    }

    function cancel() {
      if (!dragging) return;
      dragging = false;
      pointerId = null;
      moved = false;
      applyTransition(true);
      setActive(current);
    }

    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove);
    viewport.addEventListener('pointerup', onPointerUp);
    viewport.addEventListener('pointercancel', cancel);

    viewport.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    measure();
    card.dataset.carouselReady = '1';
  }

  // Cards init lazily as they approach the viewport: a collection page renders
  // 20+ of them and measuring every one during load forced synchronous layouts.
  var lazyInitObserver = null;
  if (typeof IntersectionObserver !== 'undefined') {
    lazyInitObserver = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            lazyInitObserver.unobserve(entries[i].target);
            init(entries[i].target);
          }
        }
      },
      { rootMargin: '300px 0px' }
    );
  }

  function scheduleInit(card) {
    if (card.dataset.carouselReady === '1') return;
    if (lazyInitObserver) {
      lazyInitObserver.observe(card);
    } else {
      init(card);
    }
  }

  function initAll(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-card-product-carousel]');
    for (var i = 0; i < cards.length; i++) {
      scheduleInit(cards[i]);
    }
  }

  function start() {
    initAll(document);

    // Watch only the product grid container for newly-injected cards
    // (filters, infinite scroll). Fallback to body if the container
    // isn't present yet.
    var target =
      document.getElementById('ProductGridContainer') ||
      document.getElementById('product-grid') ||
      document.body;

    if (!target || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!(node instanceof Element)) continue;
          if (node.matches && node.matches('[data-card-product-carousel]')) {
            scheduleInit(node);
          } else if (node.querySelectorAll) {
            var found = node.querySelectorAll('[data-card-product-carousel]');
            for (var k = 0; k < found.length; k++) scheduleInit(found[k]);
          }
        }
      }
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
